import superagent from 'superagent'
import isNil from 'lodash/isNil'

export const weaponTypesSet = types => ({
  type: 'WEAPON_TYPES_SET',
  payload: types
})

export const weaponTypesFetchRequest = () => (dispatch, getState, token) => {
  const weaponTypes = getState().weaponTypes
  return !isNil(weaponTypes) && weaponTypes.length > 0 ? Promise.resolve(weaponTypes) :
    new Promise(resolve => {
      superagent
        .get(`${__API_URI__}/weapon/get?folder=small35`)
        .set('Authorization', `Bearer ${token}`)
        .set('Content-Type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (!res) return resolve(null)
          if (err) return resolve(null)
          resolve(res.body)
          dispatch(weaponTypesSet(res.body))
        })
    })
}
